import { v4 as uuidv4 } from 'uuid';
import { CONSTANTS } from '../constants/constants';

const RISE_AI_INSIGHTS_FILE_NAME_SUFFIX = '-RiseAI-Insights.pdf';
const ERROR_MESSAGE = 'Failed to generate RiseAI Insights PDF. Please try again later.';

/**
 * Builds task params for queueing a RiseAI Insights PDF download.
 * @param {string} assetId - Asset/component ID
 * @param {string} formattedAssetName - Asset name with spaces replaced (e.g. underscores)
 * @param {{ onSuccess?: (response: any) => void, onError?: () => void }} callbacks - Optional success/error handlers
 * @returns Task params for use with setTasks (e.g. setTasks(prev => [taskParams, ...prev]))
 */
export function createRiseAIPdfTaskParams(assetId, formattedAssetName, callbacks = {}) {
  const { onSuccess = () => {}, onError = () => {} } = callbacks;
  const fileName = `${formattedAssetName}${RISE_AI_INSIGHTS_FILE_NAME_SUFFIX}`;

  return {
    id: uuidv4(),
    type: CONSTANTS.TASKS.TYPE.DOWNLOAD_HTTP_POST,
    status: CONSTANTS.TRANSACTION_ASSET.LOCAL_STATUS.CREATED,
    fileName,
    downloadUrl: 'generate-pdf',
    body: {
      assetId,
      templateType: 'riseai',
      fileName
    },
    headers: {},
    onSuccess,
    onError,
    errorMessage: ERROR_MESSAGE
  };
}
